export default __webpack_public_path__ + "img/1955fac875fb61f229fd1b00919e0fb0.svg";